/**
 * fork: https://git.leyantech.com/dongxiao.wang/chat-viewer/-/blob/master/src/dataTypes/Translation.ts
 * write by dongxiao.wang
 */

class Translation {
  token: string = '';
  to: string = 'zh';
  constructor(to?: string) {
    this.to = to || 'zh';
  }

  async refreshToken() {
    return fetch('https://edge.microsoft.com/translate/auth')
      .then((response) => {
        //response.status表示响应的http状态码
        if (response.status === 200) {
          return response.text();
        } else {
          return '';
        }
      })
      .then((data) => (this.token = data));
  }

  getHeaders() {
    return new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${this.token}`,
      Accept: 'application/json',
    });
  }

  async getTranslate(source: Array<String>): Promise<Map<string, string>> {
    const filterdSource = source.filter((item) => Boolean(item));
    if (filterdSource.length === 0) {
      return new Map();
    }
    if (!this.token) {
      await this.refreshToken();
    }

    return await this._getTranslate(filterdSource);
  }

  async _getTranslate(source: Array<String>): Promise<Map<string, string>> {
    if (!this.token) {
      return new Map();
    }
    return fetch(
      `https://api.cognitive.microsofttranslator.com/translate?api-version=3.0&from=&to=${this.to}&textType=plain`,
      {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify(
          source.map((item) => {
            return { Text: item };
          }),
        ),
      },
    )
      .then((response) => {
        //response.status表示响应的http状态码
        if (response.status === 200) {
          return response.json();
        } else if (response.status === 401) {
          this.token = '';
        } else {
          return [];
        }
      })
      .then((data) => {
        if (data.length !== source.length) {
          return new Map();
        }
        const ret: Map<String, String> = new Map();
        for (let idx: number = 0; idx < data.length; idx++) {
          ret.set(source[idx], data[idx].translations.map((item: any) => item.text).join('.'));
        }
        return ret;
      });
  }
}

export default Translation;
